<template>
 <div class="wrapper">
  <section class="header">
    <div class="color-wrap">      
    </div>
    <div class="info-wrap">
      <div class="img-wrap">
        <img 
        :src="img.icp_logo" 
        alt="">
      </div>
      <div class="text-wrap">
        <h1>New Financial Advisor Education Program from Risk Experts at RiXtrema</h1>
        <h3>
          Investing Counterpoint
        </h3>
        <p>
          Investing Counterpoint is a weekly show for financial advisors about portfolio risk management. Follow us if you want to get better at managing risk and become a trusted risk advisor
        </p>
        <p><b>Follow Us</b></p>
        <div>
          <a href="https://podcasts.apple.com/us/podcast/rixtrema/id1466695263" target="_blank">
            <img 
            :src="img.apple_podcast_header" 
            alt=""
            >
          </a>
          <a href="https://soundcloud.com/rixtrema" target="_blank">
            <img 
            class="img" 
            :src="img.soundcloud_header" 
            alt=""
          >
          </a>
          <a href="https://www.youtube.com/user/rixtrema" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a>
          <a href="https://twitter.com/RiXtrema" target="_blank">
            <img 
            class="img" 
            :src="img.twitter" 
            alt=""
          >
          </a>
          <a href="https://www.instagram.com/rixtrema/" target="_blank">
            <img 
            class="img" 
            :src="img.insta" 
            alt=""
          >
          </a>
          <a href="https://www.facebook.com/RiXtrema" target="_blank">
            <img 
            class="img" 
            :src="img.fb" 
            alt=""
          >
          </a> -->
          
        </div>
      </div>
    </div>
  </section>



  <!-- upd 270723 -->

  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/8DrP5I337qg" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            ⚡How To Construct The Perfect Portfolio (2023) 
          </h2>
        </div>
        <div class="description">
          <p>
            This week how to pick stocks and bonds in 2023, the old fashioned way. Yon talks to Max Wasserman, CEO and founder of Miramar Capital in Chicago, about how to tailor risk to individual clients and construct a portfolio.

          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/how-to-construct-the-perfect-portfolio-2023-ep-23">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/how-to-construct-the-perfect-portfolio-2023-ep-23/id1466695263?i=1000610595358">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/8DrP5I337qg" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 250423 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/8DrP5I337qg" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            ⚡How To Construct The Perfect Portfolio (2023) 
          </h2>
        </div>
        <div class="description">
          <p>
            This week how to pick stocks and bonds in 2023, the old fashioned way. Yon talks to Max Wasserman, CEO and founder of Miramar Capital in Chicago, about how to tailor risk to individual clients and construct a portfolio.

          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/how-to-construct-the-perfect-portfolio-2023-ep-23">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/how-to-construct-the-perfect-portfolio-2023-ep-23/id1466695263?i=1000610595358">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/8DrP5I337qg" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 200423 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/UUmFsK5LaYI" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            ⚡Black Swan in Oil Coming? Will OPEC+ break up or break US? 
          </h2>
        </div>
        <div class="description">
          <p>
            This Week,  Saudi Arabia and the OPEC cartel.  By forcing the supply/demand equation of oil,Saudi Arabia  wields enormous power over the global economy; by keeping production costs low and prices high. So, will the latest cuts trigger a black swan event and can the U.S finally break up the cartel? 
Daniel and Yon assess the risks-Watch Now! 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/black-swan-in-oil-coming-will-opec-break-up-or-break-us">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/black-swan-in-oil-coming-will-opec-break-up-or-break-us/id1466695263?i=1000609967969">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/UUmFsK5LaYI" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 270323-2 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/fcZfBT1ovRQ" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            ⚠️ Where does Bitcoin & USD go from here? Opportunity of a lifetime? 
          </h2>
        </div>
        <div class="description">
          <p>
            Big governments hate crypto, but can they defeat it?
            Are we witnessing the great decoupling of crypto from the mainstream financial markets? This is the question that Dan and Yon are wrestling with this week. 
            One thing is clear: the Whitehouse and the IMF are certainly not going to make it easy for Bitcoin, both institutions have written huge tomes on how and why they will destroy Bitcoin. 
            Dan is our resident crypto expert, Yon is still holding out as our skeptic, can he be persuaded? 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/where-does-bitcoin-usd-go-from-here-opportunity-of-a-lifetime-ep-21">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/where-does-bitcoin-usd-go-from-here-opportunity-of/id1466695263?i=1000605778647">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/fcZfBT1ovRQ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 270323-1 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/2Y1T9v-aJj8" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            🚀Good Technology leads to happy clients 
          </h2>
        </div>
        <div class="description">
          <p>
            Circle Black CEO, Lincoln Ross, joins us this week to discuss how his company uses technology to help advisors serve client needs, something that has a lot of overlap with Rixtrema’s product. Yon and Lincoln break down how advisors go about getting a holistic picture of a client’s finances and the tech challenges Circle Black and Rixtrema are trying to solve.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/good-technology-leads-to-happy-clients-ep-20">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/good-technology-leads-to-happy-clients-ep-20/id1466695263?i=1000605779963">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/2Y1T9v-aJj8" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 160323-2 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/Keh1WsVZryc" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Which bank blows up next and what blowback follows? Stress testing your portfolio (Ep. 19) 
          </h2>
        </div>
        <div class="description">
          <p>
            
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/which-bank-blows-up-next-and-what-blowback-follows-stress-testing-your-portfolio-ep-19">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/which-bank-blows-up-next-and-what-blowback-follows/id1466695263?i=1000604537336">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/Keh1WsVZryc" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 160323-1 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/hNN-Gxtd-9A" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Fed's Powell Crushes It (the middle class) ? Inflation monster is back. (Ep. 18) 
          </h2>
        </div>
        <div class="description">
          <p>
            Chairman Powell essentially repeated his mantra "higher for longer", which somehow surprised the markets. In this video we examine history and consequences of this policy for your portfolio.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/feds-powell-crushes-it-the-middle-class-inflation-monster-is-back-ep-18">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/feds-powell-crushes-it-the-middle-class-inflation/id1466695263?i=1000604535145">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/hNN-Gxtd-9A" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 090223-2 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/2uAQbV4sBIQ" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            How you may fail in portfolio risk (what to do about it) 
          </h2>
        </div>
        <div class="description">
          <p>
            Most financial advisors are using portfolio risk measures that are just extensions of a discredited method to measure risk; risks that led to several financial collapses. These risk numbers only work in normal conditions; like an umbrella that opens only when there is no rain.  Watch the show to understand  why and how to solve the problem. 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/how-you-may-fail-in-portfolio-risk-what-to-do-about-it-ep-17">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/how-you-may-fail-in-portfolio-risk-what-to-do-about-it-ep-17/id1466695263?i=1000598935466">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/2uAQbV4sBIQ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 090223-1 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/NUtiuDwo4nY" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Why is silver leaving London Vaults? And is gold joining in?

          </h2>
        </div>
        <div class="description">
          <p>
            Thousands of tons of silver left LBMA vaults leading up to the end of 2022. This hemorrhage is historically unprecedented and gold is now joining in. This bodes very well for precious metals prices, but what does it mean for risks in the financial markets in 2023? Watch to find out...
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/why-is-silver-leaving-london-vaults-and-is-gold-joining-in?si=e01811af5d654ffda510febbfce23cc0&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/why-is-silver-leaving-london-vaults-and-is-gold-joining-in/id1466695263?i=1000594742992">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/NUtiuDwo4nY" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 29112022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/o82sywLDHp4" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            FTX COLLAPSE: Risk Management Lessons to Save Your Money
          </h2>
        </div>
        <div class="description">
          <p>
            The FTX collapse is a cautionary tale of many things, greed and hubris among them of course, but also a failure to really appreciate the importance of risk management. Many unsophisticated investors wonder why you would need to bother with complex models, when you can simply invest in an index fund or base your strategy on financial press hype. 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/ftx-collapse-risk-management-lessons-to-save-your-money-ep-15?si=85d04a4a58c5414d9afae1ecc3412acf&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/ftx-collapse-risk-management-lessons-to-save-your-money/id1466695263?i=1000587921460">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/o82sywLDHp4" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 17.11.2022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/NUtiuDwo4nY" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Black Swan Put Protection: How to Impement It in Your Portfolio
          </h2>
        </div>
        <div class="description">
          <p>
            Options, particularly put options, have a big role in risk management. In this video we discuss how S&P 500 put options can hedge risks and how much it costs to employ put options to hedge risks. 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/black-swan-put-protection-how-to-impement-it-in-your-portfolio?si=4ed0e0f1ba5a43d3b49800488bbe2b2b&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/black-swan-put-protection-how-to-impement-it-in-your/id1466695263?i=1000586590695">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/NUtiuDwo4nY" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 07.11.2022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/twRmH4F5r8U" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            London Silver Vaults EMPTIED? Will Precious Metals Hedge Inflation?
          </h2>
        </div>
        <div class="description">
          <p>
            Federal Reserve Chairman Powell roiled the markets with his press conference. After the 75 bps rate hike market participants thought that the pivot is near and tightening will be paused. Power cold water or rather ice buckets on that notion. Yon and Daniel discuss how you can protect your portfolio in the case of continuing inflation and rising interest rates. Daniel also brings up the amazing case of silver inventory hemorrhage from the London Vaults.  
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/london-silver-vaults-emptied-will-precious-metals-hedge-inflation-ep-13?si=24785983085e4df69e80a7b4770cd75d&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/london-silver-vaults-emptied-will-precious-metals-hedge/id1466695263?i=1000585173346">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/twRmH4F5r8U" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 25.10.2022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/dU6sWcaxoKs" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Biden Takes China to the Brink, Chip & Yuan Mayhem 
          </h2>
        </div>
        <div class="description">
          <p>
            Biden administration punched China in the microchip solar plexus with unexpectedly tough sanctions. This happened at the same time Yuan is under pressure and political power is consolidated in China. What does this mean for your portfolio?  
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/biden-takes-china-to-the-brink-chip-yuan-mayhem">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/biden-takes-china-to-the-brink-chip-yuan-mayhem/id1466695263?i=1000583876478">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/dU6sWcaxoKs" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 19.10.2022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/GIQk4SZo2_c" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Bond and Stock Carnage: Will Bitcoin Become the Least Dirty Shirt? 
          </h2>
        </div>
        <div class="description">
          <p>
            Is Bitcoin going to become a truly diversifying asset? Will it become true stable money? Or will it falter through mistakes and/or government intervention? Join this lively discussion with portfolio risk experts and learn what you need to know about crypto. 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/bond-and-stock-carnage-will-bitcoin-become-the-least-dirty-shirt">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/bond-and-stock-carnage-will-bitcoin-become-the/id1466695263?i=1000583058757">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/GIQk4SZo2_c" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- upd 05.10.2022 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/m3w8Y4PgrqE" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Europe Implosion or Yen Collapse: What's more dangerous for your client's portfolio?
          </h2>
        </div>
        <div class="description">
          <p>
            We see multiple crises playing out simultaneously. Europe imploding over lack of energy, British pound and gilts (equivalent of treasuries) imploding, US dollar causing pain for anyone with USD denominated debt and Japanese yen is under pressure. How is this going to impact your clients' portfolios? It will in a big way, even if they don't hold any of those regions directly. 
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/europe-implosion-or-yen-collapse-whats-more-dangerous-for-your-clients-portfolio">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/europe-implosion-or-yen-collapse-whats-more-dangerous/id1466695263?i=1000581674944">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/m3w8Y4PgrqE" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- Upd: 20.09.2022 -->
   <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/JoepJ2iJ3TY" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Nowhere to Hide or Diversify: <br> What Can Advisors Do?
          </h2>
        </div>
        <div class="description">
          <p>
            In this shocking episode you will see that many of the concepts that financial advisors take for granted are no longer true in today's markets. We will examine the dangers to your clients' portfolios and show you proof that diversification by asset allocation is about to fail big time.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/nowhere-to-hide-or-diversify-what-can-advisors-do">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/nowhere-to-hide-or-diversify-what-can-advisors-do/id1466695263?i=1000580095754">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/JoepJ2iJ3TY" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- Upd 18.09.22 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/mJ5zGW7HSm4" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            RPAG 2022-Main Takeaways: The Evolution of Target Date Funds, Managed Accounts and Defining Risk
          </h2>
        </div>
        <div class="description">
          <p>
            Flying solo today, I am in sunny San Diego for the annual RPAG conference. In this episode, I’ll be talking about all the cool stuff I learned from the best in the retirement advisory business.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/rpag-2022-main-takeaways-the-evolution-of-target-date-funds-managed-accounts-and-defining-risk">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a target="_blank" href="https://podcasts.apple.com/us/podcast/rpag-2022-main-takeaways-the-evolution-of-target/id1466695263?i=1000579571378">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/mJ5zGW7HSm4" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- Upd 090922 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/Hk3wkrOLCvk" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Et tu Europe? How to Stress Test Europe For Your Client Portfolios...
          </h2>
        </div>
        <div class="description">
          <p>
            Everyone pays attention to Jerome Powell and the Fed. But ECB has now joined the anti-party, effectively announcing 75 basis points rate increase and signaling more to come. This will do nothing to fight inflation, which is created by supply shocks, but will derail businesses in Europe. How is it going to affect your client portfolios? Watch and find out.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a target="_blank" href="https://soundcloud.com/rixtrema/et-tu-europe-how-to-stress-test-europe-for-your-client-portfolios">
          <img 
          :src="img.soundcloud_header"  
          alt="SoundCloud"
          target="_blank"
          >
        </a>
        <a href="https://podcasts.apple.com/us/podcast/et-tu-europe-how-to-stress-test-europe-for-your-client/id1466695263?i=1000578560586">
          <img 
          :src="img.apple_podcast_header"  
          alt="Apple Podcasts"
          target="_blank"
          >
        </a>
        <a href="https://youtu.be/Hk3wkrOLCvk" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
<!-- Upd: Aug 29.08.22 -->
<section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/dBTI8JVAyNk" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Fed Playing Poker & Where Do We Go From Here with Housing?

          </h2>
        </div>
        <div class="description">
          <p>
            Fed Reserve Chairman Powell delivered remarks confirming that there is "pain" ahead and"forceful" rates increases will not stop. We discuss the consequences of this for your client portfolio risk management. Yon shows some interesting housing charts. Do you need to stress test housing for your clients now? Watch the show and find out.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a href="https://soundcloud.com/rixtrema/fed-playing-poker-where-do-we-go-from-here-with-housing">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/fed-playing-poker-where-do-we-go-from-here-with-housing/id1466695263?i=1000577704998">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >
        </a>
        <a href="https://www.youtube.com/watch?v=dBTI8JVAyNk&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ&index=7" target="_blank">
          <img 
          class="img" 
          :src="img.youtube" 
          alt=""
          >
        </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
<!-- Upd: Aug 19, 22 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/miLZlhoCobg" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Stress Testing the Bear Market Rally & Emerging Markets Hard Landing
          </h2>
        </div>
        <div class="description">
          <p>
            As the market roars higher and many experts are surprised, we take a look at how financial adivsors can discusss these events with clients. Markets are going up with recession in the economy, declining oil price, declining housing and significant softness in the data out of China. Given all this data we show you how to stress test Emerging Markets Hard Landing and how to discuss it with your clients.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">         
        <a href="https://soundcloud.com/rixtrema/stress-testing-the-bear-market-rally-emerging-markets-hard-landing">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/how-to-manage-risk-of-missing-out-during-a/id1466695263?i=1000575145133">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >
        </a>
        <a href="https://www.youtube.com/watch?v=bOhju6ynybA&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>    
  </section>
  <!-- sec 1 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/bOhju6ynybA" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            How to Manage Risk of MIssing Out During a Face Ripping Bear Market Rally?
          </h2>
        </div>
        <div class="description">
          <p>
            In the prior three episodes we discussed various stress tests financial advisors should run on their client's portfolios to model effects of possible stagflation, yield curve inversion and deterioration in the tech sector. For the last week we have seen an exuberant market ripping higher. How to communicate with your clients and properly manage risk without sacrificing returns during this time?
          </p>
        </div>
      </div>
      <div class="btn-wrapper">  
        
        <a href="https://soundcloud.com/rixtrema/how-to-manage-risk-of-missing-out-during-a-face-ripping-bear-market-rally">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/how-to-manage-risk-of-missing-out-during-a/id1466695263?i=1000575145133">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >

        </a>
        <a href="https://www.youtube.com/watch?v=bOhju6ynybA&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>
    <!-- <div class="audio-wrapper">
      <div id="soundcloud"></div>
      <div id="apple"></div>
    </div> -->
  </section>
  <!-- sec 2 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/nEoDQ0mlzHU" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            How to Model Internet Volatiliy and Its' Impact on Your Clients' Portfolios
          </h2>
        </div>
        <div class="description">
          <p>
            SNAP recently reported dismal earnings and stopped future guidance altogther. How can you model the impact of this event and general deterioration of Big Tech earnings on your clients' portfolios? In this episode we run stress tests around yield curve scenarios and discuss internet shocks. Learn how to discuss these issues as a financial advisor with your clients.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">  
        
        <a href="https://soundcloud.com/rixtrema/how-to-model-internet-volatiliy-and-its-impact-on-your-clients-portfolios">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/how-to-model-internet-volatiliy-and-its-impact-on/id1466695263?i=1000571358815">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >

        </a>
        <a href="https://www.youtube.com/watch?v=bOhju6ynybA&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>
    <!-- <div class="audio-wrapper">
      <div id="soundcloud"></div>
      <div id="apple"></div>
    </div> -->
  </section>
  <!-- sec 3 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/1x3vkibvbJ4" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Will the Fed invert the yield curve and cause recession? 
          </h2>
        </div>
        <div class="description">
          <p>
             Daniel and Yon discuss possible scenarios and stress testing clients' portfolios for different shapes of the yield curve. What happens if Fed keeps increasing short term rates, long term interest rates fall? Find out in this episode of the Investing Counterpoint Episode 2
          </p>
        </div>
      </div>
      <div class="btn-wrapper">  
        
        <a href="https://soundcloud.com/rixtrema/will-the-fed-invert-the-yield-curve-and-cause-recession-investing-counterpoint-episode-2">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/will-the-fed-invert-the-yield-curve-and/id1466695263?i=1000570489764">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >

        </a>
        <a href="https://www.youtube.com/watch?v=bOhju6ynybA&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>
    <!-- <div class="audio-wrapper">
      <div id="soundcloud"></div>
      <div id="apple"></div>
    </div> -->
  </section>
  <!-- sec 4 -->
  <section>
    <iframe 
    width="560" 
    height="315" 
    src="https://www.youtube.com/embed/35smsh5plng" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowfullscreen
    ></iframe>
    <div class="wrapper-info">
      <div class="text-wrap">
        <div class="title">
          <h2>
            Stagflationary Recession or Stagflation? How to Model Federal Reserve Actions
          </h2>
        </div>
        <div class="description">
          <p>
            The Fed is taking a hawkish stance to quell rampant inflation, but doing so on the verge of a potential recession. Given this and the recent supply shocks, increasing the Fed Funds Rate to 3.5% may have unintended consequences. Yon Perullo and Daniel  of RiXtrema explain how financial advisors should model these scenarios to clients.
          </p>
        </div>
      </div>
      <div class="btn-wrapper">  
        
        <a href="https://soundcloud.com/rixtrema/stagflationary-recession-or-stagflation-how-to-model-federal-reserve-actions">
        <img 
        :src="img.soundcloud_header"  
        alt="SoundCloud"
        target="_blank"
        ></a>
        <a href="https://podcasts.apple.com/us/podcast/stagflationary-recession-or-stagflation-how-to-model/id1466695263?i=1000569542132">
        <img 
        :src="img.apple_podcast_header"  
        alt="Apple Podcasts"
        target="_blank"
        >

        </a>
        <a href="https://www.youtube.com/watch?v=bOhju6ynybA&list=PLjlLfD73RvTQ-PK1CrZhs9IhmPeg1kfTJ" target="_blank">
            <img 
            class="img" 
            :src="img.youtube" 
            alt=""
          >
          </a>
          <!-- <a href="https://www.linkedin.com/company/rixtrema-inc./" target="_blank">
            <img 
            class="img" 
            :src="img.linkedin" 
            alt=""
          >
          </a> -->
      </div>
    </div>
    <!-- <div class="audio-wrapper">
      <div id="soundcloud"></div>
      <div id="apple"></div>
    </div> -->
  </section>
  
 </div>
</template>
<script>
// import Linkedin from '@/components/linkedin/index.vue'
export default{
 name: 'Investingcounterpoint', 
 components:{
  // Linkedin
 },
 data() {
  return{
    img: {
      soundcloud: require("@/components/about/soundcloud.png"),
      icp_logo: require("@/components/about/podcast-logo.jpg"),
      apple_podcast: require("@/components/about/apple_podcast_logo.png"),
      apple_podcast_header: require("@/components/about/apple-podcasts.png"),
      soundcloud_header: require("@/components/about/soundcloud-head.png"),
      youtube: require("@/components/about/youtube.png"),
      linkedin: require("@/components/about/600px-LinkedIn_logo_initials.png"),
      twitter: require("@/components/about/twitter.png"),
      insta: require("@/components/about/instagram.png"),
      fb: require("@/components/about/fb.png"),
    }
  }  
 },
 mounted() {
  this.soundcloud();
  this.applePodcast();
  this.soundcloud_2();
  this.applePodcast_2();
  this.soundcloud_3();
  this.applePodcast_3();
  this.soundcloud_4();
  this.applePodcast_4();
  
 },
  methods: {
  soundcloud(){
   let souncloud = document.getElementById("soundcloud");
   souncloud.innerHTML = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1318604341&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/rixtrema" title="RiXtrema" target="_blank" style="color: #cccccc; text-decoration: none;">RiXtrema</a> · <a href="https://soundcloud.com/rixtrema/how-to-manage-risk-of-missing-out-during-a-face-ripping-bear-market-rally"  target="_blank" style="color: #cccccc; text-decoration: none;">How to Manage Risk of MIssing Out During a Face Ripping Bear Market Rally?</a></div>`
   },
   soundcloud_2(){
   let souncloud = document.getElementById("soundcloud_2");
   souncloud.innerHTML = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1312831993&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/rixtrema" title="RiXtrema" target="_blank" style="color: #cccccc; text-decoration: none;">RiXtrema</a> · <a href="https://soundcloud.com/rixtrema/how-to-model-internet-volatiliy-and-its-impact-on-your-clients-portfolios" title="How to Model Internet Volatiliy and Its&#x27; Impact on Your Clients&#x27; Portfolios" target="_blank" style="color: #cccccc; text-decoration: none;">How to Model Internet Volatiliy and Its&#x27; Impact on Your Clients&#x27; Portfolios</a></div>`
   },

   soundcloud_3(){
   let souncloud = document.getElementById("soundcloud_3");
   souncloud.innerHTML = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1308020347&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/rixtrema" title="RiXtrema" target="_blank" style="color: #cccccc; text-decoration: none;">RiXtrema</a> · <a href="https://soundcloud.com/rixtrema/will-the-fed-invert-the-yield-curve-and-cause-recession-investing-counterpoint-episode-2" title="Will the Fed invert the yield curve and cause recession? Investing Counterpoint Episode 2" target="_blank" style="color: #cccccc; text-decoration: none;">Will the Fed invert the yield curve and cause recession? Investing Counterpoint Episode 2</a></div>`
   },
  
  soundcloud_4(){
   let souncloud = document.getElementById("soundcloud_4");
   souncloud.innerHTML = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1303311505&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/rixtrema" title="RiXtrema" target="_blank" style="color: #cccccc; text-decoration: none;">RiXtrema</a> · <a href="https://soundcloud.com/rixtrema/stagflationary-recession-or-stagflation-how-to-model-federal-reserve-actions" title="Stagflationary Recession or Stagflation? How to Model Federal Reserve Actions" target="_blank" style="color: #cccccc; text-decoration: none;">Stagflationary Recession or Stagflation? How to Model Federal Reserve Actions</a></div>`
   },

  applePodcast(){
   let apple = document.getElementById("apple")
   apple.innerHTML = `<iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="175" style="width:100%;max-width:660px;overflow:hidden;background:transparent;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.podcasts.apple.com/us/podcast/how-to-manage-risk-of-missing-out-during-a/id1466695263?i=1000575145133"><\/iframe>`
  },
  applePodcast_2(){
   let apple = document.getElementById("apple_2")
   apple.innerHTML = `<iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="175" style="width:100%;max-width:660px;overflow:hidden;background:transparent;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.podcasts.apple.com/us/podcast/how-to-model-internet-volatiliy-and-its-impact-on/id1466695263?i=1000571358815"><\/iframe>`
  },
  applePodcast_3(){
   let apple = document.getElementById("apple_3")
   apple.innerHTML = `<iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="175" style="width:100%;max-width:660px;overflow:hidden;background:transparent;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.podcasts.apple.com/us/podcast/will-the-fed-invert-the-yield-curve-and/id1466695263?i=1000570489764"><\/iframe>`
  },
  applePodcast_4(){
   let apple = document.getElementById("apple_4")
   apple.innerHTML = `<iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="175" style="width:100%;max-width:660px;overflow:hidden;background:transparent;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.podcasts.apple.com/us/podcast/stagflationary-recession-or-stagflation-how-to-model/id1466695263?i=1000569542132"><\/iframe>`
  },

},
 
}



</script>
<style lang="sass" scoped>
.router-wrapper
  margin-top: 0 !important
  background: white
.wrapper
  display: flex !important
  flex-direction: column
  justify-content: center
  align-items: center
  margin: 0 auto
  .header
    width: 100%
    display: flex
    flex-direction: column
    height: 500px
    justify-content: flex-start
    margin-top: 0
    margin-bottom: 20px
    .color-wrap
      width: 100%
      height: 220px
      background: #2d4186
      display: flex
      justify-content: center
      align-items: center
      h1
        color: #fff
    .info-wrap
      display: flex
      flex-wrap: wrap
      width: 100% 
      height: 230px      
      display: flex
      justify-content: center 
      background: white        
      .img-wrap        
        width: 250px
        height: 140px
        margin-right: 30px
        img
          width: 250px
          height: 250px          
          background: white
          border-radius: 15px
          box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px
          margin-top: -130px
      .text-wrap
        display: flex
        // position: absolute
        flex-direction: column
        width: 600px
        // top: 100px
        h1
          margin-top: -100px
          color: #fff
        h3
          font-size: 2em          
          margin-top: 15px
        p 
          font-size: 1.2em
          margin-top: 15px
        div
          display: flex
          margin-top: 20px
          a
            img
              // width: 150px
              height: 36px
              margin-right: 15px
            .img
              height: 36px
  section
    width: 100%
    display: flex    
    justify-content: center
    flex-wrap: wrap
    align-items: center
    margin: 20px 0 50px 0
    .wrapper-info
      width: 600px
      height: 315px
      margin-left: 30px
      .text-wrap
        height: 210px        
        .description
          p
            font-size: 1em
            margin-top: 20px
      .btn-wrapper
        display: flex
        flex-direction: row
        align-items: center
        margin-top: 20px
        a
          margin-right: 15px
          img
            height: 40px

        div
          margin: 10px
@media (max-width: 897px)
  .router-wrapper
    margin-top: 0 !important
    background: white
  .wrapper
    display: flex !important
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 0 auto
    .header
      width: 100%
      display: flex
      flex-direction: column
      height: 500px
      .color-wrap
        width: 100%
        height: 220px
        background: #2d4186
        display: flex
        justify-content: center
        align-items: center
        h1
          color: #fff
      .info-wrap
        display: flex
        flex-wrap: wrap
        width: 100% 
        height: 230px      
        display: flex
        justify-content: center 
        background: white        
        .img-wrap        
          width: 150px
          // height: 140px
          margin-right: 30px
          img
            width: 150px
            height: 150px          
            background: white
            border-radius: 15px
            box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px
            margin-top: -75px
        .text-wrap
          display: flex
          // position: absolute
          flex-direction: column
          width: 400px
          // top: 100px
          h1
            margin-top: -100px
            color: #fff
          h3
            font-size: 2em          
            margin-top: 15px
          p 
            font-size: 1.2em
            margin-top: 15px
          div
            display: flex
            margin-top: 20px
            a
              img
                // width: 150px
                height: 36px
                margin-right: 15px
              .img
                height: 36px


@media (max-width: 696px)
  .router-wrapper
    margin-top: 0 !important
    background: white
  .wrapper
    display: flex !important
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 0 auto
    .header
      width: 100%
      display: flex
      flex-direction: column
      justify-content: flex-start
      height: 500px
      .color-wrap
        width: 100%
        height: 220px
        background: #2d4186
        display: flex
        justify-content: center
        align-items: center
        h1
          color: #fff
      .info-wrap
        display: flex
        flex-wrap: wrap
        width: 100% 
        height: 230px      
        display: flex
        justify-content: center 
        background: white        
        .img-wrap     
          display: none   
          width: 150px
          // height: 140px
          margin-right: 30px
          img
            width: 150px
            height: 150px          
            background: white
            border-radius: 15px
            box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px
            margin-top: -75px
        .text-wrap
          display: flex
          // position: absolute
          flex-direction: column
          width: 400px
          // top: 100px
          h1
            margin-top: -100px
            color: #fff
          h3
            font-size: 2em          
            margin-top: 15px
          p 
            font-size: 1.2em
            margin-top: 15px
          div
            display: flex
            margin-top: 20px
            a
              img
                // width: 150px
                height: 36px
                margin-right: 15px
              .img
                height: 36px


@media (max-width: 440px) 

  .router-wrapper
    margin-top: 0 !important
    background: white
  .wrapper
    // padding: 0 15px
    display: flex !important
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 0 auto
    .header
      width: 100%
      display: flex
      flex-direction: column
      justify-content: flex-start
      height: 450px
      .color-wrap
        width: 100%
        height: 165px
        background: #2d4186
        display: flex
        justify-content: center
        align-items: center
        h1
          color: #fff
      .info-wrap
        display: flex
        flex-wrap: wrap
        width: 100% 
        height: 230px      
        display: flex
        justify-content: center 
        background: white        
        .img-wrap     
          display: none   
          width: 150px
          // height: 140px
          margin-right: 30px
          img
            width: 150px
            height: 150px          
            background: white
            border-radius: 15px
            box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px
            margin-top: -75px
        .text-wrap
          display: flex
          // position: absolute
          flex-direction: column
          width: 400px
          padding: 0 15px
          // top: 100px
          h1
            margin-top: -100px
            color: #fff
            font-size: 1.8em
          h3
            font-size: 1.7em          
            margin-top: 30px
          p 
            font-size: 1.2em
            margin-top: 15px
          div
            display: flex
            margin-top: 20px
            a
              img
                // width: 150px
                height: 36px
                margin-right: 15px
              .img
                height: 36px
    section
      width: 100%
      display: flex    
      justify-content: center
      flex-wrap: wrap
      align-items: center
      margin: 20px 10px
      iframe
        margin-bottom: 10px
      .wrapper-info
        width: 100%
        height: 360px
        margin-left: 0
        padding: 0 15px
        .text-wrap
          height: 250px  
          .title
            margin-top: 10px      
          .description
            margin-top: 10px
            p
              font-size: 1em
              margin-top: 0px
        .btn-wrapper
          width: 100%
          display: flex
          flex-wrap: wrap
          flex-direction: row
          justify-content: flex-start
          align-items: center
          margin-top: 20px
          a
            margin-right: 15px
            img
              height: 30px

          div
            margin: 10px  
  

  
      
</style>
